import React, { useState } from "react";
import I from "../component/Icon";
export default function SettingsPage() {
  const [tab,setTab]=useState("roles");
  const [prefs,setPrefs]=useState({email:true,sms:true,report:false,dark:false,tfa:true});
  const roles=[{name:"Super Admin",users:1,c:"#2563EB",perms:["Full Access"]},
  // {name:"School Coordinator",users:8,c:"#F97316",perms:["Schools","Teachers","Students"]}
];
  return (
    <>
      <div className="ph"><div className="ph-t">Settings</div><div className="ph-s">Roles & Permissions · Exam Templates · System Preferences</div></div>
      <div className="tabs-bar">
        {[{id:"roles",ic:"role",l:"Roles & Permissions"},
        // {id:"templates",ic:"template",l:"Exam Masters"},
        // {id:"prefs",ic:"pref",l:"Preferences"},
        {id:"account",ic:"lock",l:"Account"}].map(t=>(
          <button key={t.id} className={`tab-btn${tab===t.id?" on":""}`} onClick={()=>setTab(t.id)} style={{display:"flex",alignItems:"center",gap:5}}><I n={t.ic} s={11}/>{t.l}</button>
        ))}
      </div>
      {tab==="roles"&&(
        <div>
          {/* <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}><div style={{fontWeight:700,fontSize:14}}>Role Management</div><button className="btn btn-p"><I n="plus" s={13} c="#fff"/> Add Role</button></div> */}
          <div className="g2">
            {roles.map((r,i)=>(
              <div key={i} className="card cp">
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:11}}>
                  <div style={{display:"flex",alignItems:"center",gap:9}}>
                    <div style={{width:38,height:38,background:r.c+"20",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center"}}><I n="shield" s={18} c={r.c}/></div>
                    <div><div style={{fontWeight:700,fontSize:13.5}}>{r.name}</div><div style={{fontSize:11,color:"var(--t3)"}}>{r.users} user{r.users!==1?"s":""}</div></div>
                  </div>
                  <button className="btn btn-g btn-sm"><I n="edit" s={11}/> Edit</button>
                </div>
                <div className="sec-tag">Permissions</div>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>{r.perms.map(p=><span key={p} className="tc" style={{fontSize:9.5}}>{p}</span>)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* {tab==="templates"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontWeight:700,fontSize:14}}>Exam Masters</div><button className="btn btn-p"><I n="plus" s={13} c="#fff"/> New Category</button></div>
          <div className="g2">
            {[{n:"Manthan Category",t:"Manthan",d:"120 min",q:80,c:"#2563EB",bg:"#EFF6FF"},{n:"Shabhas Category",t:"Shabhas",d:"180 min",q:100,c:"#10B981",bg:"#ECFDF5"},{n:"ICS Category",t:"ICS",d:"90 min",q:60,c:"#F97316",bg:"#FFF7ED"},{n:"Proficiency Category",t:"Proficiency",d:"60 min",q:50,c:"#7C3AED",bg:"#F5F3FF"}].map((t,i)=>(
              <div key={i} className="card cp">
                <div style={{width:40,height:40,background:t.bg,borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:10}}><I n="template" s={18} c={t.c}/></div>
                <div style={{fontWeight:700,fontSize:13,marginBottom:4}}>{t.n}</div>
                <div style={{fontSize:11.5,color:"var(--t3)",marginBottom:10}}>{t.t} · {t.d} · {t.q} Qs</div>
                <div style={{display:"flex",gap:7}}><button className="btn btn-o btn-sm" style={{flex:1}}>Preview</button><button className="btn btn-g btn-sm" style={{flex:1}}><I n="edit" s={11}/> Edit</button></div>
              </div>
            ))}
          </div>
        </div>
      )} */}
      {/* {tab==="prefs"&&(
        <div className="g2">
          <div className="card cp">
            <div style={{fontWeight:700,fontSize:13.5,marginBottom:14}}>Notification Preferences</div>
            {[["Email Notifications","email"],["Two-factor Auth","tfa"]].map(([l,k])=>(
              <div key={k} className="perm-row">
                <div style={{fontSize:13,fontWeight:600}}>{l}</div>
                <div className="tog" style={{background:prefs[k]?"var(--p)":"var(--bd)"}} onClick={()=>setPrefs(p=>({...p,[k]:!p[k]}))}>
                  <div className="tok" style={{left:prefs[k]?20:3}}/>
                </div>
              </div>
            ))}
            <button className="btn btn-p" style={{marginTop:16}}><I n="check" s={13} c="#fff"/> Save</button>
          </div>
        </div>
      )} */}
      {tab==="account"&&(
        <div className="g2">
          <div className="card cp">
            <div style={{fontWeight:700,fontSize:13.5,marginBottom:14}}>Change Password</div>
            <div style={{display:"flex",flexDirection:"column",gap:11}}>
              <div className="fg"><label className="fl">Current Password</label><input className="fi" type="password" placeholder="••••••••"/></div>
              <div className="fg"><label className="fl">New Password</label><input className="fi" type="password" placeholder="••••••••"/></div>
              <div className="fg"><label className="fl">Confirm Password</label><input className="fi" type="password" placeholder="••••••••"/></div>
              <button className="btn btn-p"><I n="lock" s={13} c="#fff"/> Update Password</button>
            </div>
          </div>
          {/* <div className="card cp">
            <div style={{fontWeight:700,fontSize:13.5,marginBottom:14}}>Security</div>
            {[["Two-Factor Auth",true],["Login Alerts",true]].map(([t,on])=>(
              <div key={t} className="perm-row">
                <div style={{fontSize:13,fontWeight:600}}>{t}</div>
                <div className="tog" style={{background:on?"var(--p)":"var(--bd)"}}><div className="tok" style={{left:on?20:3}}/></div>
              </div>
            ))}
          </div> */}
        </div>
      )}
    </>
  );
}